module.exports = __webpack_public_path__ + "ecfb77055e52e50ee0208e0e5ab0b9b0.png";